import React, { Component } from "react";
import { FiCast, FiDollarSign, FiUsers, FiMonitor } from "react-icons/fi";
import {
  UncontrolledAccordion,
  AccordionItem,
  AccordionBody,
  AccordionHeader,
} from "bootstrap";
import Collapse from "react-bootstrap/Collapse";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

const Faqs = (props) => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [FaqList, setFaqList] = useState([
    {
      title: "Why EcoShift? What is its purpose?",
      description:
        "EcoShift’s purpose is to accelerate the transition to eco-friendly consumption, for everyone's enjoyment.\nBecause each of us can choose how we impact.\nBecause we all can act and enjoy!",
      active: false,
    },
    {
      title: "What is EcoShift?",
      description:
        "EcoShift is a digital platform allowing users to reduce their impact by interacting with certified eco-professionals located nearby, and if needed in other locations.\nEcoShift users are eco-conscious individuals and businesses. We call them everyday heroes!\nBy acting positively and sharing great experiences EcoShift’s community contributes to building an enjoyable future for all.",
      active: false,
    },
    {
      title: "Where can I find EcoShift?",
      description: "The EcoShift app can be downloaded from the <a href=\"https://apps.apple.com/app/id6804629990\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"text-decoration:underline\">Apple App Store</a> and the <a href=\"https://play.google.com/store/apps/details?id=ecoshift.eco\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"text-decoration:underline\">Google Play Store</a>, in every European store. EcoShift covers Belgium for now: the certified eco-pros listed are Belgian.",
      active: false,
    },
    {
      title: "When was EcoShift created?",
      description: "EcoShift started as a project several years before it was officially created as a company mid-2025 in Brussels, Belgium. Meeting hundreds of eco-conscious citizens and eco-certified professionals allowed to refine the early concept and develop the platform.\nTwo experienced professionals started together. Recently several individuals joined the team, together with Nature!",
      active: false,
    },
    {
      title:
        "Why only certified professionals on EcoShift? Is EcoShift certified?",
      description:
        "In order to ensure a high level of eco-responsibility, only professionals who fulfill demanding eco-responsible standards and who are certified by a trusted third-party are selected. Certificates are visible on the app, on the card of each professional.\nEven if EcoShift is a young and small company, we also started the journey to fulfill demanding eco-responsible standards, to be third-party certified and will share details when achieved.",
      active: false,
    },
  ]);

  const [FaqList2, setFaqList2] = useState([
    {
      title: "Why onboarding Nature?",
      description: "Simply because we are all part of Nature and taking Nature into account in all we do is the best way to protect Nature and to grow sustainably.",
      active: false,
    },
    {
      title: "How is Nature Onboarded? And What is the role of Nature?",
      description: "Corporate Regeneration* is appointed to represent Nature on EcoShift board of management.\nA person, member of Corporate Regeneration, has a seat, a voice and votes at the board.\n*Corporate Regeneration asbl is a Belgian legal non-profit organization of public interest. More info here: <a target=\"_blank\" href=\"https://www.corporateregeneration.org\" style={{ textDecoration: \"underline\" }}>www.corporateregeneration.org</a>",
      active: false,
    },
    {
      title: "Is EcoShift generating eco-anxiety?",
      description: "No, on the contrary! EcoShift helps making eco-positive choices that have better impact, generates a genuine satisfaction, and contributes to the common good.",
      active: false,
    },
    {
      title: "Is it free to download and use the app?",
      description: "Yes, the app will be free of charge!\nHowever, we recommend accepting notifications as those ensure a much better app experience, will support your prefered eco-pros, and will allow valuable interaction with the EcoShift community.\nPlease note that you can choose the quantity of notifications you accept to receive.",
      active: false,
    },
    {
      title: "Where does EcoShift cash come from / go to?",
      description: "EcoShift cash comes exclusively from its founders. We are financially independent, free to act responsibly, driven by our values, not by outside interests (this important!).\nIn order to stay independent, EcoShift cash generated will cover all operations to ensure fair share and fund further community developments. If any remaining, the board will cautiously allocate resources to all stakeholders starting with Nature, and communicate accordingly.",
      active: false,
    },
  ]);

  const [FaqList3, setFaqList3] = useState([
    {
      title: "Does EcoShift cater to my dietary requirements?",
      description: "Yes, of course! EcoShift takes into account the dietary requirements you set on your app profile and filters info or search results shared with you.",
      active: false,
    },
  ]);
  const [FaqList4, setFaqList4] = useState([
    {
      title: "How are EcoShift users called?",
      description: "EcoShift users are free to call themselves as they want!\nInternally we call them heroes!\nOften they call themselves EcoShifters. More and more EcoShift users show they care by adding a ⁕ to their name on their social media profiles.",
      active: false,
    },
  ]);

  const [FaqListEcoShiftProfessionnals1, setFaqListEcoShiftProfessionnals1] =
    useState([
      {
        title: "How are Professionals selected? How much does it cost to be on the platform?",
        description: "Only eco-professionals who are certified by trusted third parties according to demanding eco-friendly standards/labels are selected.\nSelected eco-pros do not pay to be on EcoShift platform.",
        active: false,
      },
      {
        title: "Can I save my favourite eco-pros?",
        description: "Sure! Just tap the bookmark sign at the top of the pro card.\nYou have direct access to your favourite list on your profile screen.",
        active: false,
      },
    ]);
  const [FaqListEcoShiftProfessionnals2, setFaqListEcoShiftProfessionnals2] =
    useState([
      {
        title: "Can I rate eco-pros and their offers?",
        description: "Sure! You can always tell us how your experience was. The rating will be only visible to us and to the professional. Your comments are very important to us in order to further improve and ensure your good experience.",
        active: false,
      },
      {
        title: "Can I recommend new professionals?",
        description: "Yes sure! Just tap the “+” button on the search page and proceed, or email us at contact@ecoshift.eco and provide us with their name and contact details. We will closely investigate if/how your recommended professional can join the community.",
        active: false,
      },
    ]);

  const [FaqListTechnicalQuestions1, setFaqListTechnicalQuestions1] = useState([
    {
      title: "How can I reset my password?",
      description: "After opening the app, when signing in with email, you can easily reset your password.\nOr after signing out in the app settings, you can also easily reset your password when signing in with email.",
      active: false,
    },
    {
      title: "Which languages are available?",
      description: "EcoShift app is currently available in 4 languages: English, French, Dutch, and German. The mobile phone’s language sets the app language. If not available among the 4 languages above, English is default.\nAt anytime, the app language can be adjusted in the app settings, at the top right of the home screen.",
      active: false,
    },
  ]);
  const [FaqListTechnicalQuestions2, setFaqListTechnicalQuestions2] = useState([
    {
      title: "Where are the data stored?",
      description: "All data are stored on our server based in Europe (Sweden).",
      active: false,
    },
    {
      title: "What if technical problems with the app?",
      description: "First close the app and start it again. If still there, uninstall and reinstall the app.\nIf still not solved, contact us at <a target=\"_blank\" href=\"mailto: contact@ecoshift.eco\" style={{ textDecoration: \"underline\" }}>contact@ecoshift.eco</a>, we value your feedback.",
      active: false,
    },
  ]);

  const handleChangeActiveFaqlist1 = (index) => {
    let shadow = JSON.parse(JSON.stringify(FaqList));
    shadow = shadow.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqList(shadow);

    let shadow2 = JSON.parse(JSON.stringify(FaqList2));
    shadow2 = shadow2.map((item, stt) => ({ ...item, active: false }));
    setFaqList2(shadow2);

    /*
    let shadow3 = JSON.parse(JSON.stringify(FaqList3));
    shadow3 = shadow3.map((item, stt) => ({ ...item, active: false }));
    setFaqList3(shadow3);
    let shadow4 = JSON.parse(JSON.stringify(FaqList4));
    shadow4 = shadow4.map((item, stt) => ({ ...item, active: false }));
    setFaqList4(shadow4);
    */
  };

  const handleChangeActiveFaqlist2 = (index) => {
    let shadow = JSON.parse(JSON.stringify(FaqList2));
    shadow = shadow.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqList2(shadow);
    let shadow2 = JSON.parse(JSON.stringify(FaqList));
    shadow2 = shadow2.map((item, stt) => ({ ...item, active: false }));
    setFaqList(shadow2);

    /*
    let shadow3 = JSON.parse(JSON.stringify(FaqList3));
    shadow3 = shadow3.map((item, stt) => ({ ...item, active: false }));
    setFaqList3(shadow3);
    let shadow4 = JSON.parse(JSON.stringify(FaqList4));
    shadow4 = shadow4.map((item, stt) => ({ ...item, active: false }));
    setFaqList4(shadow4);
    */
  };

  const handleChangeActiveFaqlist3 = (index) => {
    let shadow3 = JSON.parse(JSON.stringify(FaqList3));
    shadow3 = shadow3.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqList3(shadow3);

    /*
    let shadow = JSON.parse(JSON.stringify(FaqList));
    shadow = shadow.map((item, stt) => ({ ...item, active: false }));
    setFaqList(shadow);

    let shadow2 = JSON.parse(JSON.stringify(FaqList2));
    shadow2 = shadow2.map((item, stt) => ({ ...item, active: false }));
    setFaqList2(shadow2);
    */
    let shadow4 = JSON.parse(JSON.stringify(FaqList4));
    shadow4 = shadow4.map((item, stt) => ({ ...item, active: false }));
    setFaqList4(shadow4);
  };

  const handleChangeActiveFaqlist4 = (index) => {
    let shadow4 = JSON.parse(JSON.stringify(FaqList4));
    shadow4 = shadow4.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqList4(shadow4);

    /*
    let shadow = JSON.parse(JSON.stringify(FaqList));
    shadow = shadow.map((item, stt) => ({ ...item, active: false }));
    setFaqList(shadow);

    let shadow2 = JSON.parse(JSON.stringify(FaqList2));
    shadow2 = shadow2.map((item, stt) => ({ ...item, active: false }));
    setFaqList2(shadow2);
    */

    let shadow3 = JSON.parse(JSON.stringify(FaqList3));
    shadow3 = shadow3.map((item, stt) => ({ ...item, active: false }));
    setFaqList3(shadow3);
  };

  const handleChangeActiveFaqlistProfessionnals1 = (index) => {
    let shadow3 = JSON.parse(JSON.stringify(FaqListEcoShiftProfessionnals1));
    shadow3 = shadow3.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqListEcoShiftProfessionnals1(shadow3);

    let shadow4 = JSON.parse(JSON.stringify(FaqListEcoShiftProfessionnals2));
    shadow4 = shadow4.map((item, stt) => ({ ...item, active: false }));
    setFaqListEcoShiftProfessionnals2(shadow4);
  };

  const handleChangeActiveFaqlistProfessionnals2 = (index) => {
    let shadow3 = JSON.parse(JSON.stringify(FaqListEcoShiftProfessionnals2));
    shadow3 = shadow3.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqListEcoShiftProfessionnals2(shadow3);

    let shadow4 = JSON.parse(JSON.stringify(FaqListEcoShiftProfessionnals1));
    shadow4 = shadow4.map((item, stt) => ({ ...item, active: false }));
    setFaqListEcoShiftProfessionnals1(shadow4);
  };

  const handleChangeActiveFaqlistTechnicalQuestions1 = (index) => {
    let shadow3 = JSON.parse(JSON.stringify(FaqListTechnicalQuestions1));
    shadow3 = shadow3.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqListTechnicalQuestions1(shadow3);

    let shadow4 = JSON.parse(JSON.stringify(FaqListTechnicalQuestions2));
    shadow4 = shadow4.map((item, stt) => ({ ...item, active: false }));
    setFaqListTechnicalQuestions2(shadow4);
  };

  const handleChangeActiveFaqlistTechnicalQuestions2 = (index) => {
    let shadow3 = JSON.parse(JSON.stringify(FaqListTechnicalQuestions2));
    shadow3 = shadow3.map((item, stt) =>
      index == stt
        ? { ...item, active: !item.active }
        : { ...item, active: false }
    );
    setFaqListTechnicalQuestions2(shadow3);

    let shadow4 = JSON.parse(JSON.stringify(FaqListTechnicalQuestions1));
    shadow4 = shadow4.map((item, stt) => ({ ...item, active: false }));
    setFaqListTechnicalQuestions1(shadow4);
  };

  return (
    <React.Fragment>
      <div className="row gap-20">
        <div className="flex justify-content-left col-lg-12 align-items-left">
          <div className="section-title align-horizontal text-left mb--30 mb_sm--0">
            <p className="section-title-24">{t("About the app")}</p>
          </div>
        </div>
      </div>
      <div className="row gap-20">
        <div className="accordion custom_item" id="accordionExample">
          {FaqList.map((val, i) => (
            <div className="card" key={i} id={`heading_${i}`}
            style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}
            >
              <div className="card-header" id={`heading_${i}`}>
                <h2 className="mb-0">
                  <button
                    className="btn btn-link btn-block text-left position-relative"
                    type="button"
                    onClick={() => handleChangeActiveFaqlist1(i)}
                  >
                    <p className="item-title-medium text-left-important text-blod-description">
                      {t(val.title)}
                    </p>
                    <span
                      className={`chevron ${val.active ? "checked" : ""}`}
                    ></span>
                  </button>
                </h2>
              </div>

              <Collapse in={val.active}>
                <div id="example-collapse-text" className="card-body">
                  <p
                    className="item-description-medium text-left-important"
                    dangerouslySetInnerHTML={{ __html: t(val.description) }}
                  ></p>
                </div>
              </Collapse>
            </div>
          ))}
        </div>

        <div className="accordion custom_item" id="accordionExample2">
          {FaqList2.map((val, i) => {
            return (
              <div className="card" key={i} id={`heading_${i}`}
              style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}>
                <div className="card-header" id={`heading_${i}`}>
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left position-relative"
                      type="button"
                      onClick={() => handleChangeActiveFaqlist2(i)}
                    >
                      <p className="item-title-medium text-left-important text-blod-description">
                        {t(val.title)}
                      </p>
                      <span
                        className={`chevron ${val.active ? "checked" : ""}`}
                      ></span>
                    </button>
                  </h2>
                </div>

                <Collapse in={val.active}>
                  <div id="example-collapse-text" className="card-body">
                    <p className="item-description-medium text-left-important" dangerouslySetInnerHTML={{ __html: t(val.description) }}>
                    </p>
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      </div>

      <br />
      <br />
      <div className="row gap-20">
        <div className="flex justify-content-left col-lg-12 align-items-left">
          <div className="section-title align-horizontal text-left mb--30 mb_sm--0">
            <p className="section-title-24">{t("About users")}</p>
          </div>
        </div>
      </div>
      <div className="row gap-20">
        <div className="accordion custom_item" id="accordionExample">
          {FaqList3.map((val, i) => (
            <div className="card" key={i} id={`heading_${i}`}
            style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}>
              <div className="card-header" id={`heading_${i}`}>
                <h2 className="mb-0">
                  <button
                    className="btn btn-link btn-block text-left position-relative"
                    type="button"
                    onClick={() => handleChangeActiveFaqlist3(i)}
                  >
                    <p className="item-title-medium text-left-important text-blod-description">
                      {t(val.title)}
                    </p>
                    <span
                      className={`chevron ${val.active ? "checked" : ""}`}
                    ></span>
                  </button>
                </h2>
              </div>

              <Collapse in={val.active}>
                <div id="example-collapse-text" className="card-body">
                  <p
                    className="item-description-medium text-left-important"
                    dangerouslySetInnerHTML={{ __html: t(val.description) }}
                  ></p>
                </div>
              </Collapse>
            </div>
          ))}
        </div>

        <div className="accordion custom_item" id="accordionExample2">
          {FaqList4.map((val, i) => {
            return (
              <div className="card" key={i} id={`heading_${i}`}
              style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}>
                <div className="card-header" id={`heading_${i}`}>
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left position-relative"
                      type="button"
                      onClick={() => handleChangeActiveFaqlist4(i)}
                    >
                      <p className="item-title-medium text-left-important text-blod-description">
                        {t(val.title)}
                      </p>
                      <span
                        className={`chevron ${val.active ? "checked" : ""}`}
                      ></span>
                    </button>
                  </h2>
                </div>

                <Collapse in={val.active}>
                  <div id="example-collapse-text" className="card-body">
                    <p className="item-description-medium text-left-important" dangerouslySetInnerHTML={{ __html: t(val.description) }}>
                      
                    </p>
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      </div>


      <br />
      <br />
      <div className="row gap-20">
        <div className="flex justify-content-left col-lg-12 align-items-left">
          <div className="section-title align-horizontal text-left mb--30 mb_sm--0">
            <p className="section-title-24">{t("About EcoShift professionals")}</p>
          </div>
        </div>
      </div>
      <div className="row gap-20">
        <div className="accordion custom_item" id="accordionExample">
          {FaqListEcoShiftProfessionnals1.map((val, i) => (
            <div className="card" key={i} id={`heading_${i}`}
            style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}>
              <div className="card-header" id={`heading_${i}`}>
                <h2 className="mb-0">
                  <button
                    className="btn btn-link btn-block text-left position-relative"
                    type="button"
                    onClick={() => handleChangeActiveFaqlistProfessionnals1(i)}
                  >
                    <p className="item-title-medium text-left-important text-blod-description">
                      {t(val.title)}
                    </p>
                    <span
                      className={`chevron ${val.active ? "checked" : ""}`}
                    ></span>
                  </button>
                </h2>
              </div>

              <Collapse in={val.active}>
                <div id="example-collapse-text" className="card-body">
                  <p
                    className="item-description-medium text-left-important"
                    dangerouslySetInnerHTML={{ __html: t(val.description) }}
                  ></p>
                </div>
              </Collapse>
            </div>
          ))}
        </div>

        <div className="accordion custom_item" id="accordionExample2">
          {FaqListEcoShiftProfessionnals2.map((val, i) => {
            return (
              <div className="card" key={i} id={`heading_${i}`}
              style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}>
                <div className="card-header" id={`heading_${i}`}>
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left position-relative"
                      type="button"
                      onClick={() =>
                        handleChangeActiveFaqlistProfessionnals2(i)
                      }
                    >
                      <p className="item-title-medium text-left-important text-blod-description">
                        {t(val.title)}
                      </p>
                      <span
                        className={`chevron ${val.active ? "checked" : ""}`}
                      ></span>
                    </button>
                  </h2>
                </div>

                <Collapse in={val.active}>
                  <div id="example-collapse-text" className="card-body">
                    <p className="item-description-medium text-left-important" dangerouslySetInnerHTML={{ __html: t(val.description) }}>
                      
                    </p>
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      </div>

      <br />
      <br />
      <div className="row gap-20">
        <div className="flex justify-content-left col-lg-12 align-items-left">
          <div className="section-title align-horizontal text-left mb--30 mb_sm--0">
            <p className="section-title-24">{t("Technical questions")}</p>
          </div>
        </div>
      </div>
      <div className="row gap-20">
        <div className="accordion custom_item" id="accordionExample">
          {FaqListTechnicalQuestions1.map((val, i) => (
            <div className="card" key={i} id={`heading_${i}`}
            style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}>
              <div className="card-header" id={`heading_${i}`}>
                <h2 className="mb-0">
                  <button
                    className="btn btn-link btn-block text-left position-relative"
                    type="button"
                    onClick={() =>
                      handleChangeActiveFaqlistTechnicalQuestions1(i)
                    }
                  >
                    <p className="item-title-medium text-left-important text-blod-description">
                      {t(val.title)}
                    </p>
                    <span
                      className={`chevron ${val.active ? "checked" : ""}`}
                    ></span>
                  </button>
                </h2>
              </div>

              <Collapse in={val.active}>
                <div id="example-collapse-text" className="card-body">
                  <p
                    className="item-description-medium text-left-important"
                    dangerouslySetInnerHTML={{ __html: t(val.description) }}
                  ></p>
                </div>
              </Collapse>
            </div>
          ))}
        </div>

        <div className="accordion custom_item" id="accordionExample2">
          {FaqListTechnicalQuestions2.map((val, i) => {
            return (
              <div className="card" key={i} id={`heading_${i}`}
              style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "#8a8a8a" }}>
                <div className="card-header" id={`heading_${i}`}>
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left position-relative"
                      type="button"
                      onClick={() =>
                        handleChangeActiveFaqlistTechnicalQuestions2(i)
                      }
                    >
                      <p className="item-title-medium text-left-important text-blod-description">
                        {t(val.title)}
                      </p>
                      <span
                        className={`chevron ${val.active ? "checked" : ""}`}
                      ></span>
                    </button>
                  </h2>
                </div>

                <Collapse in={val.active}>
                  <div id="example-collapse-text" className="card-body">
                    <p className="item-description-medium text-left-important" dangerouslySetInnerHTML={{ __html: t(val.description) }}>
                      
                    </p>
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};
export default Faqs;
